import content from "../../../config/content.json";
import { VideoSectionProps } from "../../../constants/pageSectionTypes";
import useScreenSize from "../../../hooks/useScreenSize";
import { Container } from "../../common/Container/Container";
import Hero, { HeroContent } from "../../common/Hero/Hero";
import MainCallToAction, {
	MainCallToActionContent,
} from "../../common/MainCallToAction/MainCallToAction";
import TitledListWithMedia, {
	TitledListWithMediaProps,
} from "../../common/TitledListWithMedia/TitledListWithMedia";
import VideoSection from "../../common/VideoSection/VideoSection";
import forInstructors03 from "../../imagenes/how-it-works/Connected_130KB.png";
import forStudents02 from "../../imagenes/how-it-works/Connected_220KB.png";
import forInstructors02 from "../../imagenes/how-it-works/Debrief_250KB.png";
import bgImageDesktop from "../../imagenes/how-it-works/how-it-works__hero--desktop.webp";
import bgImageMobile from "../../imagenes/how-it-works/how-it-works__hero--mobile.webp";
import heroImg from "../../imagenes/how-it-works/Momentum_meter_106KB.webp";
import forFlightSchools02 from "../../imagenes/how-it-works/Students_200KB.png";
import forFlightSchools01 from "../../imagenes/how-it-works/Students_230KB.png";
import forStudents01 from "../../imagenes/how-it-works/web_mock_4-portrait_328KB.png";
import forInstructors01 from "../../imagenes/how-it-works/Within_LMS_300KB.png";
import "./HowItWorks.scss";

const heroMediaMap = {
	momentum: heroImg,
};

const forStudentsImagesMap = {
	"for-students-01": forStudents01,
	"for-students-02": forStudents02,
};

const forInstructorsImagesMap = {
	"for-instructors-01": forInstructors01,
	"for-instructors-02": forInstructors02,
	"for-instructors-03": forInstructors03,
};

const forFlightSchoolsImagesMap = {
	"for-flight-schools-01": forFlightSchools01,
	"for-flight-schools-02": forFlightSchools02,
};

const HowItWorks = () => {
	const { width } = useScreenSize();
	const isMobile = width < 768;
	const page = content.pages["how-it-works"];

	const hero = page.hero as HeroContent;
	const forStudents = page.forStudents as TitledListWithMediaProps;
	const forInstructors = page.forInstructors as TitledListWithMediaProps;
	const forFlightSchools = page.forFlightSchools as TitledListWithMediaProps;
	const mainCallToAction = page.mainCallToAction as MainCallToActionContent;
	const videoSection = page.videoSection as VideoSectionProps;

	return (
		<Container className="how-it-works" headerWithTransparentBackground>
			<Hero
				sectionContent={hero}
				isMobile={isMobile}
				bgImageMobile={bgImageMobile}
				bgImageDesktop={bgImageDesktop}
				mediaMap={heroMediaMap}
			/>
			<div className="content-container">
				<TitledListWithMedia
					{...forStudents}
					mediaMap={forStudentsImagesMap}
					className="titled-list-with-media--for-students"
				/>
				<TitledListWithMedia
					{...forInstructors}
					mediaMap={forInstructorsImagesMap}
					className="titled-list-with-media--for-instructors"
				/>
				<TitledListWithMedia
					{...forFlightSchools}
					mediaMap={forFlightSchoolsImagesMap}
					className="titled-list-with-media--for-flight-schools"
				/>
				<VideoSection sectionContent={videoSection} />
			</div>
			<MainCallToAction sectionContent={mainCallToAction} isMobile={isMobile} />
		</Container>
	);
};

export default HowItWorks;
